// extracted by mini-css-extract-plugin
export default {"tagline":"Tagline_tagline__0yOat","title":"Tagline_title__vYDzN","description":"Tagline_description__oGNLF"};